import { useLayoutEffect, useRef } from "react";

import NavBar from "../../components/fragments/NavBar";
import Footer from "../../components/fragments/Footer";
import useGuideInteractions from "../../hooks/useGuideInteractions";
import { useStaticSeo } from "../../hooks/useSeo";
import { STATIC_SEO } from "../../data/seo";
import { MANAGEMENT_GUIDE_CONTENT } from "../../data/guides/managementGuideContent";

// Shared with SalesGuide.js/LettingsGuide.js - see those files for why this
// is a plain CSS import rather than styled-components for this one piece of
// content.
import "./guideStyles.css";

export default function ManagementGuide() {
    useStaticSeo(STATIC_SEO["/management-guide"]);
    useLayoutEffect(() => {
        document.getElementById("root").scrollTo(0, 0);
    }, []);

    const containerRef = useRef(null);
    useGuideInteractions(containerRef);

    return (
        <>
            <NavBar location="public" pageTitle="Management" />
            <div
                className="guide-page management"
                ref={containerRef}
                dangerouslySetInnerHTML={{ __html: MANAGEMENT_GUIDE_CONTENT }}
            />
            <Footer />
        </>
    );
}
